import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, ListItem, Tooltip, Grid, Paper, Typography } from '@material-ui/core';
import PostAddIcon from '@material-ui/icons/PostAdd';
import DescriptionIcon from '@material-ui/icons/Description';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import { UtilsDate } from '../../../app/orussystem/utils/UtilDate';
import { menus, RUTA_REGISTRO_MEDICIONES } from '../../menu/menuJson';
import { isRutaRegistrada } from '../../menu/HelpMenuRutas';

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  box: {
    display: 'flex',
  },
  spreadBox: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  card: {
    padding: theme.spacing(3),
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    marginTop: '-3%',
    marginBottom: '3.2%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export default function ListUserMachine({ rows, isLoadUser, errorUsers, nameBascula, idBasula, primaryColor, busqueda }) {
  const classes = useStyles();
  const history = useHistory();
  // La acción de registro existe solo si la ruta está en el menú del rol en sesión
  const puedeRegistrarMediciones = useMemo(
    () => isRutaRegistrada(menus(), RUTA_REGISTRO_MEDICIONES),
    []
  );

  const goToHistorialUser = (row) => {
    const params = {
      busqueda: busqueda
    };
    let identificacion = row.numerodocumento === null ? '0000' : row.numerodocumento;
    history.push(`/mediciones/user/${nameBascula}/${idBasula}/historial/${identificacion}`, params);
  };

  const goToPreinforme = (row) => {
    const params = {
      busqueda: busqueda,
      nombre: row.firstname,
      documento: row.numerodocumento
    };
    history.push(`/mediciones/user/${nameBascula}/${idBasula}/preinforme/${row.numerodocumento}`, params);
  };

  const goToRegistroMediciones = (row) => {
    const params = {
      busqueda: busqueda,
      nombre: row.firstname,
      documento: row.numerodocumento
    };
    history.push(`/mediciones/user/${nameBascula}/${idBasula}/mediciones/${row.numerodocumento}`, params);
  };

  return (
    <>
      {isLoadUser ? (
        <Grid container direction="column" alignItems="center" role="status">
          <CircularProgress />
          <Typography>Cargando usuarios…</Typography>
        </Grid>
      ) : errorUsers ? (
        <Typography role="alert" align="center">No se pudo cargar la lista de usuarios</Typography>
      ) : rows.length === 0 ? (
        <Typography align="center">No se encontraron usuarios</Typography>
      ) : (
        rows.map((row) => (
          <Paper key={row.id} className={classes.card}>
            <Grid container spacing={1}>
              <Typography style={{ width: '11%', fontWeight: 'bold', fontSize: '17px' }}>
                {row.numerodocumento ?? "--"}
              </Typography>
              <Typography style={{ width: '13%', fontWeight: 'bold', fontSize: '17px', paddingRight: '2%' }}>
                {row.firstname ?? "--"}
              </Typography>
              <Typography style={{ width: '12%', fontWeight: 'bold', fontSize: '17px' }}>
                {row.celular ?? "--"}
              </Typography>
              <Typography style={{ width: '6%', fontWeight: 'bold', fontSize: '17px' }}>
                {row.genero ?? "--"}
              </Typography>
              <Typography style={{ width: '7%', fontWeight: 'bold', fontSize: '17px' }}>
                {row.imc == null ? '--' : row.imc.toFixed(1)}
              </Typography>
              <Typography style={{ width: '8%', fontWeight: 'bold', fontSize: '17px' }}>
                {row.igc == null ? '--' : row.igc.toFixed(1)}
              </Typography>
              <Typography style={{ width: '6%', fontWeight: 'bold', fontSize: '17px' }}>
                {row.peso == null ? '--' : row.peso}
              </Typography>
              <Typography style={{ width: '6%', fontWeight: 'bold', fontSize: '17px' }}>
                {row.altura == null ? '--' : row.altura}
              </Typography>
              <Typography style={{ width: '5%', fontWeight: 'bold', fontSize: '17px' }}>
                {`${row.sistolica ?? "--"}/${row.diastolica ?? "--"}`}
              </Typography>
              <Typography style={{ width: '10%', fontWeight: 'bold', fontSize: '17px', paddingLeft: '2%' }}>
                {UtilsDate().formatDDMMMYYYYHHmm(new Date(row.fecha_ultima_medicion)) ?? "--"}
              </Typography>
              <Typography style={{ width: '14%', marginLeft: '2%', display: 'flex' }}>
                <ListItem button onClick={() => goToHistorialUser(row)}>
                  <Tooltip title="historial de usuario" aria-label="right-end">
                    <PostAddIcon style={{ marginLeft: '5%', color: primaryColor }} />
                  </Tooltip>
                </ListItem>
                {row.numerodocumento != null && (
                  <ListItem button onClick={() => goToPreinforme(row)}>
                    <Tooltip title="preinforme" aria-label="right-end">
                      <DescriptionIcon style={{ marginLeft: '5%', color: primaryColor }} />
                    </Tooltip>
                  </ListItem>
                )}
                {row.numerodocumento != null && puedeRegistrarMediciones && (
                  <ListItem button onClick={() => goToRegistroMediciones(row)}>
                    <Tooltip title="registrar mediciones" aria-label="registrar mediciones">
                      <PlaylistAddIcon style={{ marginLeft: '5%', color: primaryColor }} />
                    </Tooltip>
                  </ListItem>
                )}
              </Typography>
            </Grid>
          </Paper>
        ))
      )}
    </>
  );
}
